package nl.astraeus.midi.view

import kotlinx.browser.document
import nl.astraeus.midi.mainCss
import nl.astraeus.midi.view.components.dropdownCss
import org.w3c.dom.HTMLStyleElement

fun renderCss() {
  val result = StringBuilder()

  result.append(dropdownCss)
  result.append(mainCss)

  (document.createElement("style") as? HTMLStyleElement)?.also { style ->
    style.type = "text/css"
    style.textContent = result.toString()

    document.head?.appendChild(style)
  }
}